import React from 'react';
import { Link } from 'react-router-dom';
import { PlusSquare, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-caces-navy text-white pt-16 pb-8" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-20">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-21">
            <div className="flex items-center gap-2" data-id="element-22">
              <div className="bg-white text-caces-navy p-1.5 rounded-md" data-id="element-23">
                <PlusSquare size={20} strokeWidth={2.5} data-id="element-24" />
              </div>
              <span className="font-serif text-2xl font-bold" data-id="element-25">CACES</span>
            </div>
            <p className="text-caces-light text-sm leading-relaxed" data-id="element-26">
              {t.footer.desc}
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 rounded-full text-xs font-medium text-caces-sky border border-white/20" data-id="element-27">
              <Clock size={12} data-id="element-28" />
              <span data-id="element-29">{t.footer.operating}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-30">
            <h3 className="font-serif text-lg font-semibold mb-6 text-caces-sky" data-id="element-31">
              {t.footer.quickLinks}
            </h3>
            <ul className="space-y-3" data-id="element-32">
              <li data-id="element-33">
                <Link to="/about" className="text-caces-light hover:text-white transition-colors text-sm" data-id="element-34">
                  {t.nav.about}
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/services" className="text-caces-light hover:text-white transition-colors text-sm" data-id="element-36">
                  {t.nav.services}
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/specialties" className="text-caces-light hover:text-white transition-colors text-sm" data-id="element-38">
                  {t.nav.specialties}
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/specialists" className="text-caces-light hover:text-white transition-colors text-sm" data-id="element-40">
                  {t.nav.specialists}
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/patients" className="text-caces-light hover:text-white transition-colors text-sm" data-id="element-42">
                  {t.nav.patients}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-43">
            <h3 className="font-serif text-lg font-semibold mb-6 text-caces-sky" data-id="element-44">
              {t.footer.services}
            </h3>
            <ul className="space-y-3" data-id="element-45">
              <li className="text-caces-light text-sm" data-id="element-46">
                {t.services.items.hospitalization.title}
              </li>
              <li className="text-caces-light text-sm" data-id="element-47">
                {t.services.items.preop.title}
              </li>
              <li className="text-caces-light text-sm" data-id="element-48">
                {t.services.items.postop.title}
              </li>
              <li className="text-caces-light text-sm" data-id="element-49">
                {t.services.items.or.title}
              </li>
              <li className="text-caces-light text-sm" data-id="element-50">
                {t.services.items.clinical.title}
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-51">
            <h3 className="font-serif text-lg font-semibold mb-6 text-caces-sky" data-id="element-52">
              {t.footer.contact}
            </h3>
            <ul className="space-y-4" data-id="element-53">
              <li className="flex items-start gap-3" data-id="element-54">
                <MapPin className="w-5 h-5 text-caces-accent shrink-0 mt-0.5" data-id="element-55" />
                <span className="text-caces-light text-sm" data-id="element-56">
                  Colonia Escalón, San Salvador, El Salvador
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-57">
                <Phone className="w-5 h-5 text-caces-accent shrink-0" data-id="element-58" />
                <span className="text-caces-light text-sm" data-id="element-59">+503 2222-0000</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-60">
                <Mail className="w-5 h-5 text-caces-accent shrink-0" data-id="element-61" />
                <span className="text-caces-light text-sm" data-id="element-62">
                  info@caces.com.sv
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 mt-8" data-id="element-63">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-64">
            <p className="text-xs text-caces-light/60 text-center md:text-left" data-id="element-65">
              © {new Date().getFullYear()} CACES. {t.footer.rights}
            </p>
            <p className="text-xs text-caces-light/60 text-center md:text-right max-w-md" data-id="element-66">
              {t.footer.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </footer>;
}